var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlaybackPauseSmall = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 32,
  height: 32
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "playback-pause-small_svg__a",
  width: 32,
  height: 32,
  x: 0,
  y: 0,
  rx: 4
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "playback-pause-small_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#playback-pause-small_svg__a"
})), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#playback-pause-small_svg__a",
  fill: "#484848",
  fillOpacity: 0.6
}), /*#__PURE__*/React.createElement("g", {
  fill: "#FFF",
  mask: "url(#playback-pause-small_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.045 22.725V9.275c0-.704.571-1.275 1.275-1.275h.951c.704 0 1.275.57 1.275 1.275v13.45c0 .704-.57 1.275-1.275 1.275h-.95c-.705 0-1.276-.57-1.276-1.275m6.409 0V9.275c0-.704.57-1.275 1.275-1.275h.95c.705 0 1.276.57 1.276 1.275v13.45c0 .704-.571 1.275-1.275 1.275h-.951c-.704 0-1.275-.57-1.275-1.275"
})))));
export default SvgPlaybackPauseSmall;